import React, { useEffect, useState } from 'react';// Import Link icon
import { CircleAlertIcon, Pencil, Trash2, ListOrdered, Info, Settings, Link, MoreVertical, ChevronRight } from 'lucide-react'
import '../shared/AccordianStyle.css';
import { motion, AnimatePresence } from 'framer-motion';
import { CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem } from "@coreui/react";
import InfoModel from './InfoModel';
import Media from './Media';



const AccordianFinal = ({ title, content, design = false, open = false, showIcon = true, isOpen, toggleAccordion, index, parentId, selectedAccordian, information, setActiveDescriptions, handleAddStatementDescription, handleFileStatementData, handleStatementFileSave, file, setFile, fileStatmentData, setParentAccordions, attachedType, differentModuleCopyFunctionality, handelSubmit }) => {
    // const [isOpen, setIsOpen] = useState(open || false);
    const [infoModelVisible, setInfoModelVisible] = useState(false)
    const [showMediaModel, setShowMediaModel] = useState(false)


    const handleConvertAndOpenMedia = () => {
        if (title?.attached) {
            const convertedData = Object.entries(title?.attached)
                .flatMap(([type, files]) =>
                    files.map(file => ({
                        url: typeof file === "object" ? file.url : file,
                        type,
                        fileName: typeof file === "object" ? file.fileName || "" : file.split('/').pop()
                    }))
                );

            setFile(convertedData);
        }

    };



    return (
        <div className="accordion-item w-full accordion-scope accordion-final-theme" style={{ minWidth: design ? '' : '500px' }}  >
            {!open && <button
                className={`accordion-button ${!isOpen ? 'collapsed' : ''} d-flex justify-content-between align-items-center border accordion-final-theme__trigger`}
                type="button"
                onClick={toggleAccordion}
                style={{
                    padding: '15px 20px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    transition: 'box-shadow 0.3s ease',
                    fontSize: '1rem',
                }}


            >
                <div className='d-flex justify-content-between align-items-center gap-2'>
                    {title.name || title}
                </div>

                {!showIcon && <div >
                    <span className="custom-icon ms-auto d-flex accordion-final-theme__icon-group" style={{ gap: '4px' }}>
                        <Info className='accordion-final-theme__icon' size={22} strokeWidth={1.5} onClick={() => {
                            setActiveDescriptions("statement")
                            handleAddStatementDescription(title)
                        }} style={{ cursor: "pointer" }} />
                        <div onClick={() => {
                            setShowMediaModel(true),
                                handleFileStatementData({
                                    parentId,
                                    attachedIndex: index,
                                    name: title.name || title,
                                }),
                                handleConvertAndOpenMedia()
                        }} className="d-flex justify-content-center align-items-center rounded-circle accordion-final-theme__media-trigger pe-accordion-badge" style={{ width: "22px", height: "22px", fontSize: "12px", border: "1.5px solid var(--ui-text-primary, #ffffff)", color: "var(--ui-text-primary, #ffffff)" }}>
                            e
                        </div>
                    </span>

                </div>}


            </button>
            }
            {showIcon && <AnimatePresence initial={false}>
                {isOpen && (
                    <motion.div
                        className="accordion-collapse "
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: 'easeInOut' }}
                    >
                        <div className="accordion-body accordion-final-theme__body">
                            {content}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>}

            {!showIcon && showMediaModel && <div>
                <Media showMediaModel={showMediaModel} setShowMediaModel={setShowMediaModel} parentId={parentId} handleFileSave={handleStatementFileSave} file={file} setFile={setFile} fileStatmentData={fileStatmentData} setParentAccordions={setParentAccordions} attachedType={attachedType} differentModuleCopyFunctionality={differentModuleCopyFunctionality} handelSubmit={handelSubmit} />
            </div>}

        </div>

    );
};

export default AccordianFinal;
